window.siteLoader = function (action) {
    if (action) {
        jQuery(".loader").removeClass("d-none");
    } else {
        jQuery(".loader").addClass("d-none");
    }
};

///// LOCAL STORAGE FUNCTIONS
window.lsSet = function (key, value) {
    localStorage.setItem(key, value);
};
window.lsGet = function (key) {
    return localStorage.getItem(key) != undefined
        ? localStorage.getItem(key)
        : "";
};
window.lsRemove = function (key) {
    localStorage.removeItem(key);
};

// ALERT FUNCTIONS
window.siteAlert = function (status, message, save) {
    if (message) {
        if (save === true) {
            lsSet(status ? "alert-success" : "alert-error", message);
        } else {
            // , extendedTimeOut: 10000000
            if (status) {
                toastr["success"](message, "Success", {
                    closeButton: true,
                    tapToDismiss: false,
                });
            } else {
                toastr["error"](message, "Error", {
                    closeButton: true,
                    tapToDismiss: false,
                });
            }
        }
    }
};
window.siteAjaxAlert = function (success, data, save) {
    if (success) {
        if (data.message != undefined) {
            siteAlert(1, data.message, save);
        }
    } else {
        if (
            data.responseJSON != undefined &&
            data.responseJSON.message != undefined
        ) {
            siteAlert(0, data.responseJSON.message, save);
        } else if (data.message != undefined) {
            siteAlert(0, data.message, save);
        } else if (data.statusText != undefined && data.statusText != "abort") {
            siteAlert(0, data.statusText, save);
        }
    }
};
window.siteSavedAlert = function () {
    if (lsGet("alert-success") && lsGet("alert-success") != undefined) {
        siteAlert(1, lsGet("alert-success"));
        lsRemove("alert-success");
    }
    if (lsGet("alert-error") && lsGet("alert-error") != undefined) {
        siteAlert(1, lsGet("alert-error"));
        lsRemove("alert-error");
    }
};

// AJAX FUNCTIONS
window.siteAjaxCall = function (params, cb) {
    let ajaxParams = {
        headers: {
            "X-CSRF-TOKEN": jQuery('meta[name="csrf-token"]').attr("content"),
        },
        type: params.method,
        url: params.url,
        data: params.data ? params.data : {},
        beforeSend:
            params.beforeSend != undefined
                ? params.beforeSend
                : function () {
                    siteLoader(1, "Please wait...");
                },
        success: function (res) {
            if (res.url) {
                siteAjaxAlert(1, res, true);
            } else {
                siteAjaxAlert(1, res);
            }
            cb(1, res);
        },
        error: function (err) {
            siteAjaxAlert(0, err);
            cb(0, err);
        },
        complete: function () {
            siteLoader(0);
        },
    };

    if (params.form !== undefined) {
        if (params.form.attr("enctype") === "multipart/form-data") {
            ajaxParams.data = new FormData(params.form[0]);
            ajaxParams.dataType = "json";
            ajaxParams.mimeType = params.form.attr("enctype");
            ajaxParams.contentType = false;
            ajaxParams.processData = false;
        }
    }
    return jQuery.ajax(ajaxParams);
};

// FORM & VALIDATE FUNCTIONS
window.siteFormValidationApply = function (form, params) {
    params = Object.assign(params, {
        ignore: [],
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.addClass("invalid-feedback");
            element.closest("div").append(error);
        },
        highlight: function (element, errorClass, validClass) {
            jQuery(element).addClass("is-invalid");
        },
        unhighlight: function (element, errorClass, validClass) {
            jQuery(element).removeClass("is-invalid");
        },
    });
    jQuery(form).validate(params);
};
window.siteFormValidate = function (form, cb) {
    siteFormValidationApply(form, {
        submitHandler: function (form) {
            if (typeof grecaptcha != "undefined") {
                siteLoader(1, "Please wait...");
                grecaptcha.ready(function () {
                    grecaptcha
                        .execute(gcaptchaKey, { action: "submit" })
                        .then(function (token) {
                            if (jQuery(form).find(".gtoken").length) {
                                jQuery(form).find(".gtoken").remove();
                            }
                            let ele = jQuery(
                                '<textarea name="gtoken" class="gtoken d-none"></textarea>',
                            );
                            ele.val(token);
                            ele.appendTo(jQuery(form));
                            siteAjaxCall(
                                {
                                    method: form.method,
                                    url: form.action,
                                    data: jQuery(form).serialize(),
                                    form: jQuery(form),
                                },
                                function (status, data) {
                                    cb(status, data);
                                },
                            );
                        });
                });
            } else {
                siteAjaxCall(
                    {
                        method: form.method,
                        url: form.action,
                        data: jQuery(form).serialize(),
                        form: jQuery(form),
                    },
                    function (status, data) {
                        cb(status, data);
                    },
                );
            }
        },
    });
};

jQuery(function () {
    // LAZY SLIDER INIT HELPER
    const lazyInitSlider = (selector, callback) => {
        const elements = jQuery(selector);
        if (!elements.length) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    callback();
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '100px' });

        elements.each(function () {
            observer.observe(this);
        });
    };

    lazyInitSlider("#sliderTestimonial", () => {
        tns({
            container: "#sliderTestimonial",
            arrowKeys: true,
            autoWidth: false,
            gutter: 10,
            controlsText: [
                '<i class="lni lni-arrow-left"></i>',
                '<i class="lni lni-arrow-right"></i>',
            ],
            autoplay: true,
            nav: false,
            autoplayButtonOutput: false,
            responsive: {
                320: {
                    items: 1,
                    gutter: 1,
                },
            },
        });
    });

    lazyInitSlider("#sliderClientLogos", () => {
        tns({
            container: "#sliderClientLogos",
            mouseDrag: true,
            autoWidth: false,
            gutter: 0,
            edgePadding: 0,
            controlsText: [
                '<i class="lni lni-arrow-left"></i>',
                '<i class="lni lni-arrow-right"></i>',
            ],
            autoplay: true,
            nav: false,
            autoplayButtonOutput: false,
            responsive: {
                320: {
                    items: 2,
                    gutter: 1,
                },
                528: {
                    items: 2,
                },
                640: {
                    items: 2,
                },
                700: {
                    items: 4,
                },
                1024: {
                    items: 6,
                },
                1440: {
                    items: 8,
                },
            },
        });
    });

    // Consolidated accessibility updates for slider controls
    setTimeout(() => {
        jQuery('[data-controls="prev"]')
            .attr("aria-label", "Prev")
            .attr("title", "Prev");
        jQuery('[data-controls="next"]')
            .attr("aria-label", "Next")
            .attr("title", "Next");
    }, 2000); // Slight delay to ensure dynamic elements are ready

    lazyInitSlider("#product-slider", () => {
        const $owl = jQuery("#product-slider");
        $owl.owlCarousel({
            items: 1,
            loop: true,
            center: true,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            smartSpeed: 700,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: true,
            dragEndSpeed: 500,
            margin: 24,
            stagePadding: 0,
            responsive: {
                0: {
                    stagePadding: 20,
                },
                576: {
                    stagePadding: 40,
                },
                768: {
                    stagePadding: 80,
                },
                992: {
                    stagePadding: 120,
                },
                1200: {
                    stagePadding: 180,
                },
                1400: {
                    stagePadding: 200,
                },
            },
        });

        // Two-finger gesture (trackpad horizontal scroll) support
        let scrollTimeout;
        $owl.on('wheel', '.owl-stage', function (e) {
            const deltaX = e.originalEvent.deltaX;
            const deltaY = e.originalEvent.deltaY;

            // Only trigger if horizontal scroll is dominant
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                e.preventDefault();
                if (scrollTimeout) return;

                if (deltaX > 20) {
                    $owl.trigger('next.owl.carousel');
                    scrollTimeout = setTimeout(() => { scrollTimeout = null; }, 500);
                } else if (deltaX < -20) {
                    $owl.trigger('prev.owl.carousel');
                    scrollTimeout = setTimeout(() => { scrollTimeout = null; }, 500);
                }
            }
        });
    });

    lazyInitSlider("#testimonial-slider", () => {
        jQuery("#testimonial-slider").owlCarousel({
            loop: true,
            nav: false,
            dots: true,
            autoplay: true,
            smartSpeed: 2000,
            margin: 15,
            stagePadding: 10,
            responsive: {
                0: {
                    items: 1,
                    margin: 10,
                },
                768: {
                    items: 2,
                    margin: 10,
                },
                992: {
                    items: 2,
                },
                1024: {
                    items: 2,
                },
                1200: {
                    items: 2,
                },
            },
        });
    });

    // COUNTER JS
    jQuery(".counter-section").each(function () {
        const section = this;
        const jQuerycounters = jQuery(section).find(".counter");
        let timers = [];

        const resetCounters = () => {
            jQuerycounters.each(function () {
                const symbol = jQuery(this).data("target").replace(/\d/g, "");
                jQuery(this).text("1" + symbol);
            });
        };

        const startCounters = () => {
            resetCounters();

            jQuerycounters.each(function () {
                const jQuerycounter = jQuery(this);
                const target = jQuerycounter.data("target");
                const number = parseInt(target.replace(/\D/g, ""));
                const symbol = target.replace(/\d/g, "");

                let startTime = null;
                const duration = 2000; // 2 seconds animation

                const step = (timestamp) => {
                    if (!startTime) startTime = timestamp;
                    const progress = Math.min((timestamp - startTime) / duration, 1);
                    const currentCount = Math.max(1, Math.floor(progress * number));

                    jQuerycounter.text(currentCount + symbol);

                    if (progress < 1) {
                        const requestId = requestAnimationFrame(step);
                        timers.push(requestId);
                    } else {
                        jQuerycounter.text(number + symbol);
                    }
                };

                const requestId = requestAnimationFrame(step);
                timers.push(requestId);
            });
        };

        const stopCounters = () => {
            timers.forEach((id) => cancelAnimationFrame(id));
            timers = [];
        };

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    startCounters();
                } else {
                    stopCounters();
                    resetCounters();
                }
            },
            {
                threshold: 0.5,
            },
        );

        observer.observe(section);
    });

    // REGISTER
    let formRegister = jQuery("#form-register");
    if (formRegister.length) {
        siteFormValidate(formRegister, function (status, data) {
            if (status) {
                formRegister[0].reset();
            }
        });
    }

    // LOGIN
    let formLogin = jQuery("#form-login");
    if (formLogin.length) {
        siteFormValidate(formLogin, function (status, data) {
            if (status) {
                if (data.url != undefined) {
                    siteLoader(1);
                    location.href = data.url;
                }
            }
        });
    }

    // FORGOT PASSWORD
    let formForgotPassword = jQuery("#form-forgot-password");
    if (formForgotPassword.length) {
        siteFormValidate(formForgotPassword, function (status, data) {
            if (status) {
                formForgotPassword[0].reset();
            }
        });
    }

    // RESET PASSWORD
    let formResetPassword = jQuery("#form-reset-password");
    if (formResetPassword.length) {
        siteFormValidate(formResetPassword, function (status, data) {
            if (status) {
                siteLoader(1);
                location.href = data.url;
            }
        });
    }

    // PROFILE
    let formProfile = jQuery("#form-my-profile");
    if (formProfile.length) {
        siteFormValidate(formProfile, function (status, data) {
            if (status) {
            }
        });
    }

    // SUBSCRIBE
    let formSubscribe = jQuery("#form-subscribe");
    if (formSubscribe.length) {
        siteFormValidate(formSubscribe, function (status, data) {
            if (status) {
                formSubscribe[0].reset();
            }
        });
    }

    // PROJECT-INQUIRY
    let formProjectInquiry = jQuery("#form-project-inquiry");
    if (formProjectInquiry.length) {
        siteFormValidate(formProjectInquiry, function (status, data) {
            if (status) {
                formProjectInquiry[0].reset();
            }
        });
    }

    // HIRE ME
    let formHireMe = jQuery("#form-hire-me");
    if (formHireMe.length) {
        siteFormValidate(formHireMe, function (status, data) {
            if (status) {
                formHireMe[0].reset();
            }
        });
    }
    let formHireDevelopers = jQuery("#form-hire-developers");
    if (formHireDevelopers.length) {
        siteFormValidate(formHireDevelopers, function (status, data) {
            if (status) {
                formHireDevelopers[0].reset();
            }
        });
    }

    // CAREER INQUIRY
    jQuery(document).on("click", ".btn-career-modal", function () {
        let div = jQuery("#careersModal");
        div.find("#career_id").val(jQuery(this).data("career_id"));
        div.modal("show");

        setTimeout(() => {
            let formCareer = jQuery("#form-career");
            if (formCareer.length) {
                siteFormValidate(formCareer, function (status, data) {
                    if (status) {
                        formCareer[0].reset();
                        div.modal("hide");
                    }
                });
            }
        }, 500);
    });

    // ADD TO CART
    let formAddToCart = jQuery("#form-add-to-cart");
    if (formAddToCart.length) {
        siteFormValidate(formAddToCart, function (status, data) {
            if (status) {
                const actionType = jQuery("#cart-action").val();

                // Update dynamic cart count if returned
                if (data.cartCount !== undefined) {
                    let createdCartDropdown = false;
                    if (!jQuery(".cart-dropdown-btn").length && data.cartCount > 0) {
                        createdCartDropdown = true;
                        const safeItem = data.item || {
                            url: "javascript:void(0);",
                            image: "/front/images/no-image.png",
                            name: "Item",
                            quantity: 1,
                            price: "",
                        };
                        const cartHtml = `
                            <div class="dropdown me-sm-3 me-2 dynamic-cart-dropdown">
                                <button class="Comman-btn Common-btn-2 cart-dropdown-btn overflow-visible d-flex align-items-center me-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Cart">
                                    <i class="lni lni-cart text-primary"></i>
                                    <span class="cart-badge">${data.cartCount}</span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-end cart-menu border-0">
                                    <div class="cart-header d-flex justify-content-between">
                                        <span>Shopping Cart</span>
                                        <span>${data.cartCount} Items</span>
                                    </div>
                                    <div class="cart-items-list">
                                        <a href="${safeItem.url}" class="cart-item">
                                            <img loading="lazy" decoding="async" src="${safeItem.image}" alt="${safeItem.name}" class="item-img">
                                            <div class="item-info">
                                                <span class="item-name">${safeItem.name}</span>
                                                <div class="item-meta">
                                                    <span>Qty: ${safeItem.quantity}</span>
                                                    <span class="item-price">${safeItem.price}</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="cart-footer">
                                        <a href="/cart" class="view-all-btn">View All Items</a>
                                    </div>
                                </div>
                            </div>
                        `;

                        const accountDropdown = jQuery(".profile-menu").closest(".dropdown").first();
                        if (accountDropdown.length) {
                            accountDropdown.before(cartHtml);
                        } else if (jQuery(".schedule-call-btn").length) {
                            jQuery(".schedule-call-btn").before(cartHtml);
                        } else {
                            jQuery("#navbarToggler").before(cartHtml);
                        }
                    }

                    let badge = jQuery(".cart-badge");
                    if (badge.length) {
                        badge.text(data.cartCount).fadeIn();
                    } else {
                        // Create badge if it doesn't exist
                        jQuery(".cart-dropdown-btn").append(
                            `<span class="cart-badge">${data.cartCount}</span>`,
                        );
                    }

                    // Update header count text
                    jQuery(".cart-header span:last-child").text(
                        `${data.cartCount} Items`,
                    );

                    // Remove "Empty Cart" message if exists
                    jQuery(".cart-items-list .text-muted").remove();

                    // Prepend new item if item data exists
                    if (data.item) {
                        if (!createdCartDropdown) {
                            const itemHtml = `
                                <a href="${data.item.url}" class="cart-item" style="display:none;">
                                    <img loading="lazy" decoding="async" src="${data.item.image}" alt="${data.item.name}" class="item-img">
                                    <div class="item-info">
                                        <span class="item-name">${data.item.name}</span>
                                        <div class="item-meta">
                                            <span>Qty: ${data.item.quantity}</span>
                                            <span class="item-price">${data.item.price}</span>
                                        </div>
                                    </div>
                                </a>
                            `;
                            jQuery(".cart-items-list").prepend(itemHtml);
                            jQuery(".cart-items-list .cart-item:first").fadeIn(500);
                        }

                        // Ensure View All button is visible
                        if (
                            jQuery(".cart-footer").length === 0 &&
                            data.cartCount > 0
                        ) {
                            const footerHtml = `
                                <div class="cart-footer">
                                    <a href="/cart" class="view-all-btn">View All Items</a>
                                </div>
                            `;
                            jQuery(".cart-menu").append(footerHtml);
                        }
                    }

                    // Premium touch: Pulse animation on icon
                    jQuery(".cart-dropdown-btn i").addClass(
                        "animate__animated animate__rubberBand",
                    );
                    setTimeout(() => {
                        jQuery(".cart-dropdown-btn i").removeClass(
                            "animate__animated animate__rubberBand",
                        );
                    }, 1000);
                }

                if (actionType === "buy-now") {
                    setTimeout(() => (location.href = data.url), 100);
                } else {
                    // Just stay on page and show success alert (already handled by siteFormValidate -> siteAjaxCall -> siteAjaxAlert)
                }
            }
        });
    }

    // Cart Add
    jQuery(document).on("click", ".btn-add-to-cart", function () {
        document.getElementById("cart-action").value =
            jQuery(this).attr("data-action-type");
        if (formAddToCart.length) {
            formAddToCart.submit();
        }
    });

    // Cart Remove
    jQuery(document).on("click", ".btn-remove-from-cart", function (e) {
        e.preventDefault();
        if (confirm("Are you sure, do you want to perform this action?")) {
            siteAjaxCall(
                {
                    method: "POST",
                    url: jQuery(this).attr("href"),
                    data: {},
                },
                (status, data) => (status ? (location.href = "") : ""),
            );
        }
    });

    let orderHistoryReq = null;
    const orderHistoryLoad = function () {
        let table = jQuery("#order-history-table");
        if (table.length) {
            orderHistoryReq = siteAjaxCall(
                {
                    method: "GET",
                    url: jQuery(this).attr("data-url"),
                    data: {
                        list: 1,
                        search: jQuery("#order-history-search").val().trim(),
                    },
                    beforeSend: function () {
                        if (orderHistoryReq != null) {
                            orderHistoryReq.abort();
                        }
                        table.find("tbody").html(`<tr>
            <td colspan="6">Loading...</td>
          </tr>`);
                    },
                },
                (status, data) => {
                    table.find("tbody").html(``);

                    let noData = true;
                    if (status) {
                        if (data.list.length) {
                            noData = false;
                            data.list.forEach((row) => {
                                table.find("tbody").append(`<tr>
                  <td><a class="text-secondary" href="${row.url}">${row.code}</a></td>
                  <td>${row.name}</td>
                  <td>${row.amount}</td>
                  <td>${row.created_at}</td>
                  <td><span class="badge text-white ${row.status == "Completed" ? "bg-success" : row.status == "Failed" ? "bg-danger" : "bg-warning"}">${row.status}</span></td>
              </tr>`);
                            });
                        }
                    }
                    if (noData) {
                        table.find("tbody").html(`<tr>
            <td colspan="6">No records found.</td>
          </tr>`);
                    }
                },
            );
        }
    };
    orderHistoryLoad();
    jQuery(document).on("keyup", "#order-history-search", function (e) {
        orderHistoryLoad();
    });

    if (typeof msgSuccess != "undefined" && msgSuccess) {
        siteAlert(1, msgSuccess);
    }
    if (typeof msgError != "undefined" && msgError) {
        siteAlert(0, msgError);
    }

    siteLoader(0);
    siteSavedAlert();
});

// CHATBOT FUNCTIONS
window.Tawk_API = window.Tawk_API || {};
window.Tawk_LoadStart = new Date();

(() => {
    let chatLoaded = false;
    const lazyEvents = ["scroll", "mousemove", "touchstart", "keydown"];

    const loadChatWidget = () => {
        if (chatLoaded) return;
        chatLoaded = true;

        const script = document.createElement("script");
        script.async = true;
        script.src = "https://embed.tawk.to/6051a040f7ce18270930e55a/1f0vdjvfu";
        script.charset = "UTF-8";
        script.setAttribute("crossorigin", "*");
        document.body.appendChild(script);
    };

    if ("requestIdleCallback" in window) {
        requestIdleCallback(loadChatWidget, { timeout: 8000 });
    } else {
        setTimeout(loadChatWidget, 5000);
    }

    lazyEvents.forEach((eventName) => {
        window.addEventListener(eventName, loadChatWidget, {
            once: true,
            passive: true,
        });
    });
})();

// LINE ANIMATION
const round = Math.round;
const min = Math.min;
const PI = Math.PI;
const sin = Math.sin;
const cos = Math.cos;
let N_CIRCLES = 8;
const K = 1.15;
let R_CIRCLE = min(80, round(1000 / (K / sin(PI / N_CIRCLES) + 1) / 2) - 1);
let R_POS = round((K * R_CIRCLE) / sin(PI / N_CIRCLES));
const NS_URI = "http://www.w3.org/2000/svg";
const XLINK_NS = "http://www.w3.org/1999/xlink";
const dl = document.getElementById("nc");
const nc_slider_el = document.getElementById("nc-slider");
const circle = document.getElementById("c");
const wrap_circle_el = document.querySelector(".circles");
const wrap_line_el = document.querySelector(".lines");
let angle_start = 0;
const angle_incr = PI / 90;
let angle_diff;
let circles;
let lines;
let n_lines;
let req_ID = null;

if (nc_slider_el && dl && circle && wrap_circle_el && wrap_line_el) {
    const setAttrs = (element, attrs) => {
        Object.keys(attrs).forEach((prop) => {
            element.setAttribute(prop, attrs[prop]);
        });
    };

    const prep = () => {
        const fragment = document.createDocumentFragment();
        for (
            let i = Number(nc_slider_el.min);
            i <= Number(nc_slider_el.max);
            i += 1
        ) {
            const option = document.createElement("option");
            option.setAttribute("label", i);
            option.innerHTML = i;
            fragment.appendChild(option);
        }
        dl.replaceChildren(fragment);
    };

    const init = () => {
        const fragCircles = document.createDocumentFragment();
        const fragLines = document.createDocumentFragment();

        if (req_ID !== null) {
            cancelAnimationFrame(req_ID);
            req_ID = null;
        }

        circles = [];
        lines = [];

        N_CIRCLES = Number(nc_slider_el.value) || 8;
        R_CIRCLE = min(80, round(1000 / (K / sin(PI / N_CIRCLES) + 1) / 2) - 1);
        R_POS = round((K * R_CIRCLE) / sin(PI / N_CIRCLES));

        const angle_base = 360 / N_CIRCLES;
        const angle_base_rad = (2 * PI) / N_CIRCLES;

        circle.setAttribute("r", R_CIRCLE);
        angle_diff = 2 * angle_base_rad;

        for (let i = 0; i < N_CIRCLES; i += 1) {
            const angle_curr = round(i * angle_base);
            const angle_curr_rad = i * angle_base_rad;
            const x = R_POS * cos(angle_curr_rad);
            const y = R_POS * sin(angle_curr_rad);

            const curr_circle_el = document.createElementNS(NS_URI, "use");
            curr_circle_el.setAttributeNS(XLINK_NS, "xlink:href", "#c");
            curr_circle_el.setAttribute(
                "transform",
                "rotate(" + angle_curr + ") translate(" + R_POS + ")",
            );

            fragCircles.appendChild(curr_circle_el);
            circles.push({
                el: curr_circle_el,
                x: x,
                y: y,
                a: i * angle_diff,
            });

            for (let j = i + 1; j < N_CIRCLES; j += 1) {
                const curr_line_el = document.createElementNS(NS_URI, "line");
                fragLines.appendChild(curr_line_el);
                lines.push({
                    el: curr_line_el,
                    idx_start: i,
                    idx_end: j,
                });
            }
        }

        n_lines = lines.length;
        wrap_circle_el.replaceChildren(fragCircles);
        wrap_line_el.replaceChildren(fragLines);

        ani();
    };

    const ani = () => {
        for (let i = 0; i < n_lines; i += 1) {
            let angle = angle_start + circles[lines[i].idx_start].a;
            const x1 = round(
                circles[lines[i].idx_start].x + R_CIRCLE * cos(angle),
            );
            const y1 = round(
                circles[lines[i].idx_start].y + R_CIRCLE * sin(angle),
            );

            angle = angle_start + circles[lines[i].idx_end].a;
            const x2 = round(circles[lines[i].idx_end].x + R_CIRCLE * cos(angle));
            const y2 = round(circles[lines[i].idx_end].y + R_CIRCLE * sin(angle));

            setAttrs(lines[i].el, { x1: x1, y1: y1, x2: x2, y2: y2 });
        }

        angle_start -= angle_incr;
        req_ID = requestAnimationFrame(ani);
    };

    prep();
    init();
    nc_slider_el.addEventListener("change", init);
}

// SMOOTH SCROLL LENIS - LIGHTWEIGHT
jQuery(function () {
    if (typeof Lenis !== "undefined") {
        const lenis = new Lenis({
            duration: 1.8,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
        });

        function lenisRaf(time) {
            lenis.raf(time);
            requestAnimationFrame(lenisRaf);
        }

        requestAnimationFrame(lenisRaf);

        // Handle anchor links for smooth scroll
        jQuery(document).on("click", 'a[href^="#"]', function (e) {
            const id = jQuery(this).attr("href");
            if (
                id &&
                id !== "#" &&
                jQuery(id).length &&
                !jQuery(this).data("bs-toggle") &&
                !jQuery(this).data("toggle")
            ) {
                e.preventDefault();
                lenis.scrollTo(id);
            }
        });
    }
});
